/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Send_Pending_AriaInputs */

const en_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending message`)
};

const ar_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ إرسال الرسالة`)
};

const bn_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বার্তা পাঠানো হচ্ছে`)
};

const de_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht wird gesendet`)
};

const es_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando mensaje`)
};

const fr_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi d'un message`)
};

const pt_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando mensagem`)
};

const zh_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送消息`)
};

const tr_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj gönderiliyor`)
};

const ru_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка сообщения`)
};

const pl_form_send_pending_aria = /** @type {(inputs: Form_Send_Pending_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłam wiadomość`)
};

/**
* | output |
* | --- |
* | "Sending message" |
*
* @param {Form_Send_Pending_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_send_pending_aria = /** @type {((inputs?: Form_Send_Pending_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Send_Pending_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_send_pending_aria(inputs)
	if (locale === "bn") return bn_form_send_pending_aria(inputs)
	if (locale === "de") return de_form_send_pending_aria(inputs)
	if (locale === "es") return es_form_send_pending_aria(inputs)
	if (locale === "fr") return fr_form_send_pending_aria(inputs)
	if (locale === "pt") return pt_form_send_pending_aria(inputs)
	if (locale === "zh") return zh_form_send_pending_aria(inputs)
	if (locale === "tr") return tr_form_send_pending_aria(inputs)
	if (locale === "ru") return ru_form_send_pending_aria(inputs)
	if (locale === "pl") return pl_form_send_pending_aria(inputs)
	return en_form_send_pending_aria(inputs)
});